
export const getDifficultyColor = (
  difficulty: string
): 'success' | 'warning' | 'error' | 'default' => {
  const colorMap: Record<string, 'success' | 'warning' | 'error' | 'default'> = {
    easy: 'success',
    moderate: 'warning',
    advanced: 'error',
  };
  return colorMap[difficulty] || 'default';
};

